
import * as React from "react";
import { IIconProps } from "./Icon";

const Icon = (props: IIconProps) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={props.width}
    className={`svg-icon ${props.className || ""}`}
    height={props.width}
    viewBox="0 0 512 512">
    <circle 
        style={{
            fill:'rgb(252, 215, 112)'
        }} 
        cx="256.35" 
        cy="256" 
        r="248.49"/>
    <g style={{opacity:0.4}}>
        <path 
            style={{
                fill:'rgb(253, 176, 112)'
            }} 
            d="M256.352,7.515c-16.789,0-33.186,1.676-49.042,4.85c114.681,22.034,201.33,122.888,201.33,243.997
            c0,120.445-85.699,220.865-199.444,243.636c15.27,2.934,31.03,4.488,47.156,4.488c137.235,0,248.485-111.251,248.485-248.485
            S393.586,7.515,256.352,7.515z"/>
    </g>
    <path d="M178.927,484.383C80.894,451.313,15.029,359.533,15.029,256c0-64.365,25.066-124.879,70.579-170.392
        S191.635,15.03,256,15.03c24.317,0,48.309,3.608,71.311,10.724c3.969,1.229,8.174-0.993,9.4-4.958
        c1.227-3.965-0.993-8.174-4.958-9.4C307.311,3.834,281.824,0,256,0C187.62,0,123.333,26.629,74.981,74.98
        C26.629,123.333,0,187.62,0,256c0,109.987,69.975,207.491,174.122,242.624c0.797,0.269,1.606,0.396,2.403,0.396
        c3.136,0,6.062-1.978,7.119-5.114C184.972,489.973,182.859,485.71,178.927,484.383z"/>
    <path d="M470.473,116.171c-26.468-40.518-63.635-72.61-107.483-92.808c-3.77-1.738-8.233-0.088-9.969,3.682
        s-0.088,8.233,3.682,9.969c41.277,19.014,76.268,49.228,101.188,87.377c25.567,39.137,39.08,84.647,39.08,131.61
        c0,64.365-25.065,124.878-70.579,170.392C380.879,471.905,320.365,496.97,256,496.97c-15.271,0-30.55-1.437-45.412-4.271
        c-4.075-0.783-8.012,1.896-8.789,5.974c-0.777,4.077,1.897,8.013,5.974,8.79C223.561,510.473,239.787,512,256,512
        c68.38,0,132.667-26.628,181.02-74.98C485.371,388.667,512,324.38,512,256C512,206.111,497.64,157.759,470.473,116.171z"/>
    <path d="M256,359.905c4.15,0,8-3.364,8-7.515V264h88.391c4.15,0,7.515-3.85,7.515-8s-3.364-8-7.515-8H264v-88.391
        c0-4.15-3.85-7.515-8-7.515s-8,3.364-8,7.515V248h-88.39c-4.15,0-7.515,3.85-7.515,8s3.364,8,7.515,8H248v88.39
        C248,356.541,251.85,359.905,256,359.905z"/>
  </svg>
);

export default Icon;
